import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ACCESS_TOKEN_KEY, getStringFromStorageGenerator } from '../utils/local-storage';
import { useSelector, useDispatch } from 'react-redux';
import { getUserDataAction } from '../store/shared/private-route.store';
import FullScreenLoading from '../components/base/full-screen-loading/full-screen-loading';

const PrivateRoute = ({children} : any) => {

  const { user } = useSelector((state: any) => {
    return state.user;
  });

  const {loading, error} = useSelector((state: any) => {
    return state.privateRoute
  })

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const token = getStringFromStorageGenerator(ACCESS_TOKEN_KEY)
    if(!token) {
      navigate('/', {replace: true})
    } else if(token && !user) {
      dispatch(getUserDataAction())
    }
  })

  useEffect(() => {
    if (error) {
      navigate('/', {replace: true})
    }
  }, [error]);

  return(
    <>
      {loading && <FullScreenLoading />}
      {user && children}
    </>
  )
}

export default PrivateRoute;

